webpackJsonp([19],{

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(499)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(502),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44d0cf4e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5MS42NCA1OC4yIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6bm9uZTtzdHJva2U6IzExOTtzdHJva2UtbGluZWNhcDpzcXVhcmU7c3Ryb2tlLWxpbmVqb2luOmJldmVsO3N0cm9rZS13aWR0aDoxMXB4O308L3N0eWxlPjwvZGVmcz48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxsaW5lIGNsYXNzPSJjbHMtMSIgeDE9IjUuNSIgeTE9IjI4Ljk4IiB4Mj0iNzcuODMiIHkyPSIyOC45OCIvPjxsaW5lIGNsYXNzPSJjbHMtMSIgeDE9IjYyLjY1IiB5MT0iNTAuNDIiIHgyPSI4My44NyIgeTI9IjI5LjIiLz48bGluZSBjbGFzcz0iY2xzLTEiIHgxPSI2Mi4xOSIgeTE9IjcuNzgiIHgyPSI4My40MSIgeTI9IjI5Ii8+PC9nPjwvZz48L3N2Zz4=");

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(500);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("5dc001f2", content, true, {});

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.backBtn[data-v-44d0cf4e] {\n  width: 40px;\n  margin: auto;\n}\n.mainDiv[data-v-44d0cf4e] {\n  text-align: center;\n  padding: 6px;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Registration/Privacy.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,aAAa;CACd;AACD;EACE,mBAAmB;EACnB,aAAa;CACd","file":"Privacy.vue","sourcesContent":["\n.backBtn[data-v-44d0cf4e] {\n  width: 40px;\n  margin: auto;\n}\n.mainDiv[data-v-44d0cf4e] {\n  text-align: center;\n  padding: 6px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "privacy",
  methods: {
    goBack: function goBack() {
      this.$router.push("/registration");
    }
  }
});

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainDiv"
  }, [_c('div', {
    staticClass: "backBtn",
    on: {
      "click": _vm.goBack
    }
  }, [_c('inline-svg', {
    staticClass: "backs-svg",
    attrs: {
      "src": __webpack_require__(224).default
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("registration.privacy.title")))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "100%",
      "font-size": "14px",
      "text-align": "var(--src-position)"
    }
  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.$t("registration.privacy.text1")) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t("registration.privacy.text2")) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t("registration.privacy.text3")) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t("registration.privacy.text4")) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("registration.privacy.text5")))]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t("registration.privacy.text6")) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("registration.privacy.text7")))]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t("registration.privacy.text8")) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t("registration.privacy.text9")) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("registration.privacy.text10")))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('registration.privacy.text11'))
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t("registration.privacy.text12")) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "backBtn",
    on: {
      "click": _vm.goBack
    }
  }, [_c('inline-svg', {
    staticClass: "backs-svg",
    attrs: {
      "src": __webpack_require__(224).default
    }
  })], 1)])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// 19.ce03fd3d81a126f24b18.bundle.js